import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace PreferredContentFormat {
  export class Enum {
    static readonly ON_DEMAND_STREAMING = new Enum(
      'ON_DEMAND_STREAMING',
      t('preferredContentFormat.ON_DEMAND_STREAMING.name'),
      t('preferredContentFormat.ON_DEMAND_STREAMING.description')
    )

    static readonly LIVE_STREAMING = new Enum(
      'LIVE_STREAMING',
      t('preferredContentFormat.LIVE_STREAMING.name'),
      t('preferredContentFormat.LIVE_STREAMING.description')
    )

    static readonly PARTIALLY_ONSITE = new Enum(
      'PARTIALLY_ONSITE',
      t('preferredContentFormat.PARTIALLY_ONSITE.name'),
      t('preferredContentFormat.PARTIALLY_ONSITE.description')
    )

    static readonly ONSITE = new Enum(
      'ONSITE',
      t('preferredContentFormat.ONSITE.name'),
      t('preferredContentFormat.ONSITE.description')
    )

    public constructor(
      public readonly key: string,
      public readonly name: string,
      public readonly description: string
    ) {}
  }

  export const getAll = (): Enum[] => Object.values(Enum)

  export const getByKey = (key: string): Enum => Object.values(Enum).find(item => key == item.key)
}
